import {createReducer, on} from "@ngrx/store";
import * as BuildingsActions from './building-queue.actions';
import {BuildingQueue} from "../../models/BuildingQueue";
export const BuildingQueueFeatureKey = 'buildingQueue';
export const BuildingQueueInitialState: BuildingQueue[] = null;
export const BuildingQueueReducer = createReducer<BuildingQueue[] | null>(
  BuildingQueueInitialState,
  on(BuildingsActions.update, (_state, { buildingQueue }) => buildingQueue),
);
